import createVueApp from '@/common/createApp'

Styxie.Initializers.AdminMomentsContentDashboard = {
  show: async(props) => {
    const { default: ContentDashboardPage } = await import('@/vue_widgets/admin/moments/content_dashboard/index.vue')
    createVueApp(ContentDashboardPage, { props })
  }
}
